// Load the existing application AND its extracted CSS as progressive enhancement.
void import('./main').then(() => document.getElementById('news-ssr-style')?.remove());
